/**
 * Legacy Drupal / old-site paths → SPA routes.
 * Normalized paths (lowercase, no trailing slash, `/ro/` stripped) are keys in App.js.
 * Keep in sync with the RewriteRule block in `laravel/public/.htaccess`.
 */
export const LEGACY_PATH_REDIRECTS = {
  "/prezentare": "/",
  "/contact": "/#contact",
  "/servicii": "/",
  "/programare": "/#booking",
  "/pilkington_centru_de_parbrize": "/parbrize-pilkington",
  "/reparatii_camioane": "/itp-auto-camioane",
  "/taxonomy/term/68": "/parbrize-pilkington",
};
